import React from "react";
import { Music2, Clapperboard } from "lucide-react";
import { useI18n } from "../i18n";
import { Section, SectionHeading } from "./Section";
import { DISCOGRAPHY, FILMOGRAPHY } from "../data/structure";

function WorkCard({ year, title, why, label, testid }) {
  const { d } = useI18n();
  return (
    <div data-testid={testid} className="group rounded-xl border border-jlo-gold/20 bg-jlo-bg2 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-jlo-gold/60">
      <div className="flex items-baseline justify-between gap-3">
        <h4 className="font-display text-lg font-semibold text-jlo-warm">{title}</h4>
        <span className="text-sm text-jlo-gold font-semibold shrink-0">{year}</span>
      </div>
      <p className="mt-3 text-xs uppercase tracking-wider text-jlo-gray font-bold">{d.worksSection.whyItMatters}</p>
      <p className="mt-1 text-sm text-jlo-warm/75 leading-relaxed">{why}</p>
    </div>
  );
}

export default function WorksHighlights({ only }) {
  const { d } = useI18n();
  const showMusic = !only || only === "music";
  const showFilm = !only || only === "film";

  return (
    <Section testid="works-highlights">
      {!only && (
        <SectionHeading kicker={d.worksSection.kicker} heading={d.worksSection.heading} />
      )}
      <div className={`mt-${only ? "4" : "14"} grid gap-12 ${!only ? "lg:grid-cols-2" : ""}`}>
        {showMusic && (
          <div>
            <h3 className="flex items-center gap-2 font-display text-2xl font-semibold text-jlo-warm mb-6">
              <Music2 className="h-5 w-5 text-jlo-gold" /> {d.worksSection.music}
            </h3>
            <div className="grid gap-4 sm:grid-cols-2">
              {DISCOGRAPHY.map((it) => {
                const c = d.discography[it.id] || {};
                return <WorkCard key={it.id} year={it.year} title={c.title} why={c.why} testid={`disc-${it.id}`} />;
              })}
            </div>
          </div>
        )}
        {showFilm && (
          <div>
            <h3 className="flex items-center gap-2 font-display text-2xl font-semibold text-jlo-warm mb-6">
              <Clapperboard className="h-5 w-5 text-jlo-gold" /> {d.worksSection.film}
            </h3>
            <div className="grid gap-4 sm:grid-cols-2">
              {FILMOGRAPHY.map((it) => {
                const c = d.filmography[it.id] || {};
                return <WorkCard key={it.id} year={it.year} title={c.title} why={c.why} testid={`film-${it.id}`} />;
              })}
            </div>
          </div>
        )}
      </div>
    </Section>
  );
}
